import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Button, Header, NavHeader } from '../../../../../../components';
import { Page } from '../../../../../../components/page';
import { ROUTES } from '../../../../../../routes/routes';
import { OverviewHeader } from '../../components/overview-header/overview-header';
import { OverviewText } from '../../components/overview-text/overview-text';
import { RoundedImage } from '../../components/rounded-image/rounded-image';

const GroupsOverview: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();

  const renderNormalText = (text: string) => <OverviewText text={text} />;

  const renderHeaderText = (text: string, bold?: boolean) => <OverviewHeader text={text} bold={bold} />;

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height p-t-0"
      header={
        <>
          <NavHeader />
          <Header title={t('groupsOverview.header')} isUnderline />
        </>
      }
    >
      <Box sx={{ maxWidth: '800px' }}>
        {renderNormalText(t('groupsOverview.description'))}
        <RoundedImage url="images/smart-home.png" />

        {renderHeaderText(t('groupsOverview.easierNavigation.title'))}
        {renderNormalText(t('groupsOverview.easierNavigation.description'))}

        {renderHeaderText(t('groupsOverview.wholeRoomControl.title'))}
        {renderNormalText(t('groupsOverview.wholeRoomControl.description'))}

        {renderHeaderText(t('groupsOverview.homePersonalization.title'))}
        {renderNormalText(t('groupsOverview.homePersonalization.description'))}

        {renderHeaderText(t('groupsOverview.fasterAutomationSetup.title'))}
        {renderNormalText(t('groupsOverview.fasterAutomationSetup.description'))}

        <Button type="accent" center fullWidth onClick={() => navigate(ROUTES.GroupCreate())}>
          {t('groupsOverview.createRoomButton')}
        </Button>
      </Box>
    </Page>
  );
};

export default GroupsOverview;
